import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-020e08f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-form-container" }
const _hoisted_2 = { class: "form-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, "建议类型（多选）", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("饭菜口味")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("饭菜卫生")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("餐厅环境")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("服务态度")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("其它")
const _hoisted_10 = { class: "form-section" }
const _hoisted_11 = { class: "section-title" }
const _hoisted_12 = {
  key: 1,
  class: "form-section"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title" }, "好评对象", -1))
const _hoisted_14 = { class: "form-section" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title-phone" }, "联系方式", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-note" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px"} }, [
    /*#__PURE__*/_createTextVNode("亲，为了快速解决问题，请留下手机号码方便我们联系您了解情况，给您提供满意解决方案。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 请放心，联系方式仅食堂经理知晓，我们会做好隐私保密。")
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Uploader } from 'vant';
import { Toast } from 'vant';
import { req } from "../axios/http";
import { addFeedBack } from "../api/schoolFeedBack"

interface FeedbackParams {
  type: string;
  content: string;
  target?: string;
  contact: string;
  timestamp: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'schoolProblemFeedForm',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const fileList = ref<File[]>([])

const checked = ref([]);

const submitForm = ref({
  type: "",
  category: "",
  orderId: "",
  schoolId: "",
  title: "",
  description: "",
  pictures: [] as string[],
  isAnonymous: true,
  memberName: "",
  phone: "",
  email: "",
  extJson: "",
  target: ""
})

const afterRead = (file: any) => {
  file.status = 'uploading';
  file.message = '上传中...';
  // 创建 FormData 对象
  const formData = new FormData();
  formData.append('file', file.file);
  req.post({
    url: "/dev/file/uploadAliyunReturnUrl",
    data: formData,
    timeout: 60000,
  }).then((res: any) => {
    file.status = 'success';
    file.message = '上传成功';
    submitForm.value.pictures.push(res.data)
  }).catch(() => {
    file.status = 'failed';
    file.message = '上传失败';
  })
};

// 表单数据
const selectedTarget = ref<string>('');
const contactInfo = ref<string>('');
const isSubmitting = ref<boolean>(false);
const showTargetPicker = ref<boolean>(false);

// 好评对象选项
const targetOptions = [
  '餐厅服务',
  '食品质量',
  '环境卫生',
  '价格问题',
  '其他'
];

// 根据路由参数确定反馈类型
const feedbackType = computed(() => {
  return route.query.type as string || 'problem';
});

// 表单标题
const formTitle = computed(() => {
  switch (feedbackType.value) {
    case 'problem':
      return '问题反馈';
    case 'suggestion':
      return '我要建议';
    case 'praise':
      return '我要好评';
    default:
      return '意见反馈';
  }
});

// 选择建议对象
const onTargetConfirm = (value: string) => {
  selectedTarget.value = value;
  submitForm.value.target = value
  showTargetPicker.value = false;
};

// 提交表单
const handleSubmit = async () => {
  if (!checked.value.length && formTitle.value == '我要建议') {
    Toast('请选择建议类型');
    return;
  }
  if (!submitForm.value.description) {
    Toast('请描述您的问题');
    return;
  }
  if (!selectedTarget.value && formTitle.value == '我要好评') {
    Toast('请选择好评对象');
    return;
  }
  // if (!submitForm.value.phone) {
  //   Toast('请输入联系方式');
  //   return;
  // }
  isSubmitting.value = true;
  submitForm.value.type = formTitle.value
  submitForm.value.category = JSON.stringify(checked.value)
  try {
    const res = await req.post({
      url: "/app/rabbit/user/common-feedback/add",
      data: submitForm.value,
    });

    if (res.code === 200) {
      Toast.success('提交成功');
      router.back();
    } else {
      Toast.fail(res.message || '提交失败');
    }
  } catch (error) {
    console.error('提交错误:', error);
    Toast.fail('网络错误，请稍后重试');
  } finally {
    isSubmitting.value = false;
  }
};

// 页面加载时初始化
onMounted(() => {
  // 可以根据需要初始化数据
});

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _unref(formTitle),
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_divider),
      (_unref(formTitle) == '我要建议')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_van_checkbox_group, {
              modelValue: checked.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checked).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_grid, { "column-num": 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_grid_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_checkbox, { name: "饭菜口味" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_grid_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_checkbox, { name: "饭菜卫生" }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_grid_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_checkbox, { name: "餐厅环境" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_grid_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_checkbox, { name: "服务态度" }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_grid_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_checkbox, { name: "其它" }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(formTitle) == '我要好评' ? '暖心好评' : '您的建议'), 1),
        _createVNode(_component_van_field, {
          modelValue: submitForm.value.description,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((submitForm.value.description) = $event)),
          rows: "2",
          autosize: "",
          type: "textarea",
          maxlength: "500",
          placeholder: _unref(formTitle) == '我要好评' ? '非常感谢您的支持与认可，愿您每天都有好心情~' : '请告诉我们您的建议，我们会认真考虑并改进~',
          "show-word-limit": ""
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_van_uploader, {
          modelValue: fileList.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fileList).value = $event)),
          "after-read": afterRead,
          style: {"background-color":"#f8f8f8","border-radius":"20px","padding":"12px","margin-top":"10px"}
        }, null, 8, ["modelValue"])
      ]),
      (_unref(formTitle) == '我要好评')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_van_cell, {
              title: "请选择好评对象",
              "is-link": "",
              value: selectedTarget.value || '',
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showTargetPicker.value = true))
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_van_field, {
          modelValue: submitForm.value.phone,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((submitForm.value.phone) = $event)),
          placeholder: "请输入联系方式",
          style: {"background-color":"#f7f8fa","border-radius":"200px"}
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_16,
      _createVNode(_component_van_button, {
        class: "submit-btn",
        type: "primary",
        block: "",
        onClick: handleSubmit,
        loading: isSubmitting.value
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_component_van_popup, {
      show: showTargetPicker.value,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((showTargetPicker).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: targetOptions,
          onConfirm: onTargetConfirm,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (showTargetPicker.value = false))
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})